import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import logo from "src/assets/images/frp-logo.svg";
import { Body, PageTitle } from "src/components/typography/typography";
import { RootState } from "src/state/reducers";
import { Routes } from "src/utils/routes";
import { Loading } from "../../components/loading/loading";

import { LoginForm } from "./forms/login_form";
import { PasswordResetForm } from "./forms/password_reset_form";
import "./login.scss";

/*
 * Main
 */

export const LoginPage = (): React.ReactElement => {
    const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
    const isAdmin = useSelector((state: RootState) => state.auth.isAdmin);
    const [showPasswordReset, togglePasswordReset] = useState(false);

    if (isLoggedIn) {
        window.location.href = isAdmin ? Routes.admin.createSchool : Routes.dashboard;
        return <Loading />;
    }

    return (
        <div className="main-page-wrap login">
            <div className="login-page-wrap">
                <div className="center">
                    <div className="login-form-outer-wrap">
                        <img alt="ACSI Flourishing School Culture Instrument" src={logo} />
                        <div className="login-form-wrap">
                            {showPasswordReset ? (
                                <>
                                    <PageTitle style={{ color: "var(--color-blue-3)" }}>Reset Password</PageTitle>
                                    <PasswordResetForm />
                                    <div className="after-form-text">
                                        <button
                                            onClick={(): void => {
                                                togglePasswordReset(!showPasswordReset);
                                            }}
                                        >
                                            Have an account?
                                        </button>
                                        <span className="after-divider">|</span>
                                        {"Having Trouble? "}
                                        <Link
                                            to={{
                                                hash: "#contact-us",
                                                pathname: Routes.about,
                                            }}
                                        >
                                            Contact Us
                                        </Link>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <PageTitle style={{ color: "var(--color-blue-3)" }}>Log in</PageTitle>
                                    <LoginForm />
                                    <div className="after-form-text">
                                        <button
                                            onClick={(): void => {
                                                togglePasswordReset(!showPasswordReset);
                                            }}
                                        >
                                            Forgot Password?
                                        </button>
                                        <span className="after-divider">|</span>
                                        {"Having Trouble? "}
                                        <Link
                                            to={{
                                                hash: "#contact-us",
                                                pathname: Routes.about,
                                            }}
                                        >
                                            Contact Us
                                        </Link>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="login-extra-content-wrap">
                        <img alt="ACSI Flourishing School Culture Instrument" src={logo} />
                        <Body>
                            ACSI’s Flourishing School Culture Instrument (FSCI) and Flourishing Faith Index (FFI)
                            provide empirically-backed, culture-level insights for your school.
                        </Body>
                        <Body>
                            Used separately or together, the FSCI and FFI deliver valuable insights for your school’s
                            strategic planning and accreditation, curricular development, spiritual life and student
                            programming, marketing and development efforts, and much more.
                        </Body>
                        <div className="register-button-wrap">
                            <a
                                className="button-style register"
                                href="https://your.acsi.org/pdp-store/Product-Catalog/Product-Details?productid=%7BFB9FD3E9-CBC5-EE11-9079-000D3A4F1A9F%7D"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                Register Your School
                            </a>
                        </div>
                        <div className="more-button-wrap">
                            <a
                                className="button-style alt-outline"
                                href="https://www.acsi.org/flourishing-school-culture/instrument"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                About FSCI
                            </a>
                            <a
                                className="button-style alt-outline"
                                href="https://www.acsi.org/flourishing-schools-culture/ffi"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                About FFI
                            </a>
                        </div>
                    </div>
                    <div className="clear" />
                </div>
            </div>
        </div>
    );
};
